export default __webpack_public_path__ + "static/media/YAS0780.34I-35631_-25343_0.63e17848.jpg";